import { useEffect, useState } from "react";
import Content from "../../../../layout/Content";
import ContentHeader from "../../../../layout/ContenteHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuilding, faUserGroup, faPlus } from "@fortawesome/free-solid-svg-icons";
import ContactCard from "../ContactCard";
import ErrorPopup from "../../../../layout/ErrorPopup";
import NewModal from "../../documents/modals/NewModal";
import { useLocation, useNavigate } from "react-router-dom";
import CrmConfig from "@serie3/freelancesplaceapi/Config/Crm/CrmConfig";
import crudApi from "@serie3/common/api/crudApi";
import ViewWrapper from "../ViewWrapper";
import listHandler from "@serie3/common/Domain/listHandler";
import getSettings from "@serie3/common/config/settings";
import PaymentModal from "../../../../layout/Payment/PaymentModal";
import { btn, btnHoverStyle } from "../../../../layout/Buttons/buttonStyles";

const Index = () => {
  const [data, setData] = useState([]);
  const [showDetails, setShowDetails] = useState(false);
  const [showRowError, setShowRowError] = useState(false);
  const [viewData, setViewData] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [settings, setSettings] = useState();

  const url = useLocation();
  const navigate = useNavigate();
  const isCompanies = url.pathname === "/crm/companies";

  useEffect(() => {
    const endpoint = isCompanies
      ? CrmConfig.company.index.endpoint
      : CrmConfig.people.index.endpoint;
    const datafield = isCompanies
      ? CrmConfig.company.index.datafield
      : CrmConfig.people.index.datafield;

    crudApi.getAll(endpoint, setData, datafield);
    setSettings(getSettings());
  }, [url.pathname]);

  const createNew = async () => {
    const newUrl = isCompanies
      ? CrmConfig.company.index.endpoint
      : CrmConfig.people.index.endpoint;
    const payload = isCompanies ? {} : { vorname: " ", name: " " };

    const response = await crudApi.createNew(newUrl, payload, setShowPayModal);
    if (response.status === 200) {
      navigate(url.pathname + "/edit/" + response.data.id);
    } else {
      setShowRowError(true);
    }
  };

  const deleteData = async (index, contact) => {
    const deleteUrl = isCompanies
      ? CrmConfig.company.index.endpoint + "delete/"
      : CrmConfig.people.index.endpoint + "delete/";

    listHandler.deleteFromList(
      index,
      crudApi.del(deleteUrl, contact.id),
      setData,
      data,
      setShowRowError
    );
  };

  const icon = isCompanies ? faBuilding : faUserGroup;
  const title = isCompanies ? "Companies" : "People";
  const subtitle = isCompanies ? "Manage your company contacts" : "Manage your personal contacts";
  const accentColor = isCompanies ? "#1a73e8" : "#7b1fa2";
  const shadowColor = isCompanies ? "rgba(26,115,232,0.3)" : "rgba(123,31,162,0.3)";

  const NewButton = () => (
    <>
      <style>{btnHoverStyle}</style>
      <button className="btn-modern" style={{ ...btn.base, ...btn.primary }} onClick={createNew}>
        <FontAwesomeIcon icon={faPlus} /> New
      </button>
    </>
  );

  const Title = () => title;

  return (
    <>
      <NewModal show={showDetails} setShow={setShowDetails}>
        <ViewWrapper contact={viewData} />
      </NewModal>
      {settings && <PaymentModal show={showPayModal} setShow={setShowPayModal} priceTableId={settings.pricingTables.crm} />}

      <ContentHeader>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{
            width: "46px",
            height: "46px",
            borderRadius: "12px",
            background: `linear-gradient(135deg, ${accentColor} 0%, ${accentColor}cc 100%)`,
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "1.2rem",
            flexShrink: 0,
            boxShadow: `0 4px 12px ${shadowColor}`,
          }}>
            <FontAwesomeIcon icon={icon} />
          </div>
          <div>
            <div style={{ fontSize: "1.5rem", fontWeight: 800, color: "#212121", lineHeight: 1.2 }}>
              {title}
            </div>
            <div style={{ fontSize: "0.85rem", color: "#9e9e9e", marginTop: "2px" }}>
              {subtitle}
            </div>
          </div>
        </div>
      </ContentHeader>

      <Content Title={Title} AdditionalButtons={NewButton}>
        {data.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px 20px", color: "#9e9e9e", fontSize: "0.95rem" }}>
            No {title.toLowerCase()} yet. Add your first contact!
          </div>
        ) : (
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
            gap: "16px",
            padding: "4px 0",
          }}>
            <ContactCard createNew={createNew} />
            {data.map((contact, index) => (
              <ContactCard
                index={index}
                key={index}
                contact={contact}
                setShowDetails={setShowDetails}
                setViewData={setViewData}
                deleteData={deleteData}
              />
            ))}
          </div>
        )}
      </Content>
    </>
  );
};

export default Index;
